import React from 'react';

import { ContextType, TTournamentParams } from '~/../api/common.types';
import ConnectedWalletProvider from '~/contextProviders/ConnectedWallerProvider';
import GameAuthenticationProvider from '~/contextProviders/GameAuthenticationProvider';
import GameContextProvider from '~/contextProviders/GameContextProvider';
import WarriorAuthenticationProvider from '~/contextProviders/WarriorAuthenticationProvider';

const CONTRACT_ADDRESS = process.env.NEXT_PUBLIC_PEACEFALL_ADDRESS || '';
// shared providers needed to verify warriors, play the game, etc
// wrap individual pages with this
export const ConnectedProviders = ({
  children,
  accessTokenRequired,
}: {
  children: any;
  accessTokenRequired?: boolean;
}) => {
  return (
    <ConnectedWalletProvider contractAddress={CONTRACT_ADDRESS}>
      <GameAuthenticationProvider accessTokenRequired={accessTokenRequired}>
        <WarriorAuthenticationProvider
          accessTokenRequired={accessTokenRequired}
        >
          {children}
        </WarriorAuthenticationProvider>
      </GameAuthenticationProvider>
    </ConnectedWalletProvider>
  );
};

export const ConnectedProvidersGame = ({
  children,
  tournamentParam,
  totalStates,
  battleId,
}: {
  children: any;
  battleId: number;
  tournamentParam: TTournamentParams;
  totalStates: ContextType[];
}) => {
  return (
    <ConnectedWalletProvider contractAddress={CONTRACT_ADDRESS}>
      <GameAuthenticationProvider accessTokenRequired={true}>
        <GameContextProvider
          battleId={battleId}
          tournamentParam={tournamentParam}
          totalStates={totalStates}
        >
          {children}
        </GameContextProvider>
      </GameAuthenticationProvider>
    </ConnectedWalletProvider>
  );
};
